export const Marquee = ({ items, dark = true }) => {
  const row = [...items, ...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-6 border-y ${dark ? "bg-terracotta text-cream border-terracotta" : "bg-creamdark text-earth border-ochre/30"}`}
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display italic text-2xl sm:text-3xl px-6">{item}</span>
                <span className={`h-2 w-2 rounded-full ${dark ? "bg-cream/70" : "bg-terracotta/60"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
